import { MatcherTypes } from "../../types/rules/MatcherTypes";
import { Matcher, MatcherProperties } from "./Matcher";
import { PageSection, PageSectionData } from "./PageSection";
import { MatcherFactory } from "./factory/MatcherFactory";

type LocationMatcherData = {
  section: PageSectionData;
  matcher: MatcherProperties;
} & MatcherProperties;

class LocationMatcher extends Matcher implements LocationMatcherData {
  discriminator: MatcherTypes = "M_LOCATION";
  section: PageSection;
  matcher: Matcher;

  position: number;
  threshold: number;
  reusable: boolean;

  constructor(data: LocationMatcherData) {
    super();
    this.position = data.position;
    this.reusable = data.reusable ?? true;
    this.threshold = data.threshold;
    this.section = new PageSection(data.section);
    this.matcher = MatcherFactory.createMatcher(data.matcher);
  }

  isConfigured(): boolean {
    return this.section.isConfigured() && this.matcher.isConfigured();
  }

  clear(): void {
    this.section.clear();
    this.matcher.clear();
  }

  toMatcherData(): LocationMatcherData {
    return {
      discriminator: this.discriminator,
      position: this.position,
      reusable: this.reusable,
      threshold: this.threshold,
      section: this.section.toSectionData(),
      matcher: this.matcher.toMatcherData(),
    };
  }

  getDiscriminator(): MatcherTypes {
    return this.discriminator;
  }

  getMatcherId(): string {
    return `${this.discriminator}-[${this.matcher.getMatcherId()}]-[${this.section.getSectionId()}]`;
  }

  static createTest(rest: Partial<LocationMatcherData> = {}): LocationMatcher {
    const data: LocationMatcherData = {
      discriminator: "M_LOCATION",
      position: 0,
      reusable: true,
      threshold: 0,
      section: PageSection.createTest({}).toSectionData(),
      matcher: {
        discriminator: "M_REGEX",
        position: 0,
        reusable: true,
        threshold: 0,
      },
    };

    return new LocationMatcher({
      ...data,
      ...rest,
    });
  }
}

export { LocationMatcher, LocationMatcherData };
